export default __webpack_public_path__ + "static/bottle-d73a6b74e7933fdc559c70d83aabd675.png";